/* Studio repair: current Liquid variants drive counts/media; preserve the existing UI. */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-wp-builder]').forEach(function (builder) {
      if (builder.dataset.wpDeepBuilderBound === 'true') return;
      var rules = window.WristPinnacleConfigurationRules;
      var currentColorwayMedia = window.WristPinnacleCurrentColorwayMedia || { mediaByModel: {} };
      if (!rules || !Array.isArray(rules.models)) return;
      builder.dataset.wpDeepBuilderBound = 'true';

      var profiles = {
        'facet-01': { family: 'integrated', function: 'date', movement: 'three-hand-date', bezel: 'angular', form: 'integrated', dial: 'three-hand-date', bracelet: ['integrated', 'strap'], price: '329', tags: ['Integrated', 'Date', 'Angular bezel'], components: [['Case', 'Integrated date case'], ['Bezel', 'Angular bezel case'], ['Dial', 'Three-hand date'], ['Bracelet', 'Integrated bracelet']] },
        'atria-02': { family: 'integrated', function: 'date', movement: 'three-hand-date', bezel: 'smooth', form: 'integrated', dial: 'three-hand-date', bracelet: 'integrated', price: '319', tags: ['Integrated', 'Date', 'Smooth bezel'], components: [['Case', 'Integrated date case'], ['Bezel', 'Smooth round bezel'], ['Dial', 'Arabic-index date'], ['Bracelet', 'Integrated bracelet']] },
        'vale-03': { family: 'integrated', function: 'no-date', movement: 'no-date', bezel: 'smooth', form: 'integrated', dial: 'no-date', bracelet: 'integrated', price: '319', tags: ['Integrated', 'No date', 'Smooth bezel'], components: [['Case', 'Integrated no-date case'], ['Bezel', 'Smooth round bezel'], ['Dial', 'Baton and triangle'], ['Bracelet', 'Integrated bracelet']] },
        'meridian-04': { family: 'meridian', function: 'gmt', movement: 'gmt-date', bezel: '24-hour', form: 'sport', dial: 'gmt-date', bracelet: 'three-link', price: '329', tags: ['Meridian', 'GMT', '24-hour bezel'], components: [['Case', 'GMT sport case'], ['Bezel', '24-hour bezel'], ['Dial', 'GMT with date'], ['Bracelet', 'Three-link bracelet']] },
        'meridian-05': { family: 'meridian', function: 'date', movement: 'three-hand-date', bezel: 'elapsed', form: 'sport', dial: 'three-hand-date', bracelet: 'three-link', price: '329', tags: ['Meridian', 'Date', 'Elapsed bezel'], components: [['Case', 'Diver sport case'], ['Bezel', 'Elapsed-time bezel'], ['Dial', 'Three-hand date'], ['Bracelet', 'Three-link bracelet']] },
        'pulse-06': { family: 'pulse', function: 'chronograph', movement: 'chronograph', bezel: 'tachymeter', form: 'chronograph', dial: 'multi-register', bracelet: ['sport', 'strap'], price: '349', tags: ['Pulse', 'Chronograph', 'Tachymeter'], components: [['Case', 'Chronograph case'], ['Bezel', 'Tachymeter scale'], ['Dial', 'Multi-register dial'], ['Bracelet', 'Sport bracelet']] },
        'coda-07': { family: 'coda', function: 'date', movement: 'three-hand-date', bezel: 'smooth', form: 'round', dial: 'three-hand-date', bracelet: 'strap', price: '319', tags: ['Coda', 'Date', 'Smooth bezel'], components: [['Case', 'Round steel date case'], ['Bezel', 'Fixed smooth round bezel'], ['Dial', 'Three-hand date'], ['Bracelet', 'Black strap']] }
      };
      var filterState = { family: 'all', function: 'all', movement: 'all', bezel: 'all', form: 'all', dial: 'all', bracelet: 'all', price: 'all' };
      var explicitFilters = new Set();
      var initialQuery = new URLSearchParams(window.location.search);
      var selectedSize = ['39', '40', '41'].includes(initialQuery.get('size')) ? initialQuery.get('size') : '40';
      var modelButtons = Array.prototype.slice.call(builder.querySelectorAll('[data-builder-model]'));
      var configurations = Array.prototype.slice.call(builder.querySelectorAll('[data-builder-configuration]'));
      var selector = builder.querySelector('[data-builder-selector]');
      var resultCount = builder.querySelector('[data-builder-result-count]');
      var noResults = builder.querySelector('[data-builder-no-results]');
      var stateLabel = builder.querySelector('[data-builder-state-label]');
      var stateCopy = builder.querySelector('[data-builder-state-copy]');
      var advancedFilters = builder.querySelector('.wp-builder__advanced');
      var manualButtons = Array.prototype.slice.call(builder.querySelectorAll('[data-builder-manual-filter]'));

      function ruleFor(handle) {
        return rules.models.find(function (model) { return model.id === handle; });
      }

      function escapeHtml(value) {
        return String(value).replace(/[&<>'\"]/g, function (character) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
        });
      }

      function componentLabel(key) {
        return {
          case: 'Case',
          bezel: 'Bezel',
          dial: 'Dial',
          crown: 'Crown',
          calendarFunction: 'Calendar or function',
          bracelet: 'Bracelet',
          finish: 'Finish or two-tone treatment',
          movement: 'Movement'
        }[key] || key;
      }

      function exactMediaFor(handle, label) {
        return currentColorwayMedia.mediaByModel && currentColorwayMedia.mediaByModel[handle]
          ? currentColorwayMedia.mediaByModel[handle][label] || ''
          : '';
      }

      function setPaletteActive(configuration, label) {
        configuration.querySelectorAll('[data-builder-palette-choice]').forEach(function (choice) {
          var selected = choice.dataset.builderPaletteLabel === label;
          choice.classList.toggle('is-active', selected);
          choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }

      function withSizePreference(url) {
        var parsed = new URL(url, window.location.origin);
        parsed.searchParams.set('size', selectedSize);
        return parsed.pathname + parsed.search + parsed.hash;
      }

      function syncSizeState(configuration) {
        if (!configuration) return;
        configuration.querySelectorAll('[data-builder-size]').forEach(function (button) {
          var active = button.dataset.builderSize === selectedSize;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var sizeDisclosure = configuration.querySelector('[data-builder-size-disclosure]');
        if (sizeDisclosure && selectedSize !== '40') sizeDisclosure.open = true;
        var qualifier = selectedSize === '40' ? ' / standard' : ' / by confirmation';
        var sizeCopy = selectedSize + ' mm preference' + qualifier;
        var visualSize = configuration.querySelector('[data-builder-visual-size]');
        var summarySize = configuration.querySelector('[data-builder-summary-size]');
        if (visualSize) visualSize.textContent = sizeCopy;
        if (summarySize) summarySize.textContent = sizeCopy;
        var visualLink = configuration.querySelector('[data-builder-visual-link]');
        var productLink = configuration.querySelector('[data-builder-product-link]');
        if (visualLink) visualLink.href = withSizePreference(visualLink.href);
        if (productLink) productLink.href = withSizePreference(productLink.href);
      }

      function syncAllSizeStates() {
        configurations.forEach(syncSizeState);
        var currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('size', selectedSize);
        window.history.replaceState({}, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
      }

      function syncSelectedColorway(configuration, button) {
        if (!configuration || !button) return;
        var label = button.dataset.builderVariantLabel || button.textContent.trim();
        var image = configuration.querySelector('[data-builder-visual-image]');
        var visualModel = configuration.querySelector('[data-builder-visual-model]');
        var visualColor = configuration.querySelector('[data-builder-visual-color]');
        var visualPrice = configuration.querySelector('[data-builder-visual-price]');
        var visualLink = configuration.querySelector('[data-builder-visual-link]');
        var observation = configuration.querySelector('[data-builder-observation]');
        if (observation) observation.textContent = button.dataset.variantObservation || '';
        var selectedDetails = { Dial: button.dataset.variantDial, Bracelet: button.dataset.variantBracelet };
        var profile = profiles[configuration.dataset.builderConfiguration];
        var architecture = configuration.querySelector('[data-builder-architecture]');
        if (profile && architecture) {
          architecture.textContent = profile.components.map(function (component) {
            return selectedDetails[component[0]] || component[1];
          }).join(' · ') + '.';
        }
        configuration.querySelectorAll('[data-builder-components] .wp-builder__component').forEach(function (component) {
          var labelNode = component.querySelector('span');
          var valueNode = component.querySelector('strong');
          var category = labelNode.textContent === 'Bracelet / strap' ? 'Bracelet' : labelNode.textContent;
          if (selectedDetails[category] && valueNode) valueNode.textContent = selectedDetails[category];
          if (category === 'Bracelet') labelNode.textContent = 'Bracelet / strap';
        });
        ['dial', 'bracelet'].forEach(function (category) {
          var value = category === 'dial' ? button.dataset.variantDial : button.dataset.variantBracelet;
          var detailChoice = configuration.querySelector('[data-component-category="' + category + '"]');
          if (value && detailChoice) detailChoice.textContent = value;
        });
        var summaryOption = configuration.querySelector('[data-builder-summary-option]');
        var summaryPrice = configuration.querySelector('[data-builder-summary-price]');
        var productLink = configuration.querySelector('[data-builder-product-link]');
        var exactMedia = button.dataset.variantMedia || exactMediaFor(configuration.dataset.builderConfiguration, label);
        if (image && exactMedia) {
          image.style.opacity = '0';
          window.setTimeout(function () {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = exactMedia;
            image.alt = button.dataset.variantMediaAlt || label;
            image.style.opacity = '1';
          }, 80);
        }
        if (visualModel) visualModel.textContent = configuration.querySelector('h2').textContent.trim();
        if (visualColor) visualColor.textContent = label;
        if (visualPrice) visualPrice.textContent = button.dataset.variantPrice;
        if (visualLink) visualLink.href = withSizePreference(button.dataset.variantUrl);
        if (summaryOption) summaryOption.textContent = label;
        if (summaryPrice) summaryPrice.textContent = button.dataset.variantPrice;
        if (productLink) productLink.href = withSizePreference(button.dataset.variantUrl);
        var selectionUrl = new URL(window.location.href);
        selectionUrl.searchParams.set('model', configuration.dataset.builderConfiguration);
        selectionUrl.searchParams.set('variant', button.dataset.variantId);
        selectionUrl.searchParams.set('size', selectedSize);
        window.history.replaceState({}, '', selectionUrl.pathname + selectionUrl.search + selectionUrl.hash);
        setPaletteActive(configuration, label);
        syncSizeState(configuration);
      }

      function renderPalette(configuration, handle) {
        // Count the actual Shopify-rendered finishes, not the old planning manifest.
        var variants = Array.prototype.slice.call(configuration.querySelectorAll('[data-builder-variant]'));
        var summary = configuration.querySelector('[data-builder-palette-summary]');
        var currentContainer = configuration.querySelector('[data-builder-palette-current]');
        if (summary) summary.textContent = variants.length + ' made-to-order ' + (variants.length === 1 ? 'finish' : 'finishes') + ' for this watch.';
        if (currentContainer) {
          currentContainer.innerHTML = variants.map(function (button) {
            var label = button.dataset.builderVariantLabel || button.textContent.trim();
            var media = button.dataset.variantMedia || exactMediaFor(handle, label);
            var thumbnail = media ? '<img src="' + escapeHtml(media) + '" alt="" loading="lazy" class="wp-builder__palette-thumb">' : '';
            return '<button class="wp-builder__palette-choice" type="button" data-builder-palette-choice data-builder-palette-label="' + escapeHtml(label) + '" aria-pressed="false">' + thumbnail + '<span><b>Current</b>' + escapeHtml(label) + '</span></button>';
          }).join('');
        }
      }

      function profileValues(handle, group) {
        var profile = profiles[handle];
        if (!profile) return [];
        var value = profile[group];
        return Array.isArray(value) ? value : (value == null ? [] : [value]);
      }

      function matchesFilters(handle, ignoredGroup) {
        if (!profiles[handle]) return true;
        return Object.keys(filterState).every(function (group) {
          if (group === ignoredGroup || !explicitFilters.has(group)) return true;
          return filterState[group] === 'all' || profileValues(handle, group).indexOf(filterState[group]) !== -1;
        });
      }

      function availableValuesFor(group) {
        var values = [];
        modelButtons.forEach(function (card) {
          var handle = card.dataset.builderModel;
          if (!matchesFilters(handle, group)) return;
          profileValues(handle, group).forEach(function (value) {
            if (values.indexOf(value) === -1) values.push(value);
          });
        });
        return values;
      }

      function reconcileFilterState(preferredGroup) {
        var changed = true;
        while (changed) {
          changed = false;
          Array.from(explicitFilters).forEach(function (group) {
            if (group === preferredGroup) return;
            var availableValues = availableValuesFor(group);
            if (filterState[group] !== 'all' && availableValues.indexOf(filterState[group]) === -1) {
              filterState[group] = 'all';
              explicitFilters.delete(group);
              changed = true;
            }
          });
        }
        Object.keys(filterState).forEach(function (group) {
          if (explicitFilters.has(group)) return;
          var availableValues = availableValuesFor(group);
          filterState[group] = availableValues.length === 1 ? availableValues[0] : 'all';
        });
      }

      function syncFilterControls() {
        Object.keys(filterState).forEach(function (group) {
          var availableValues = availableValuesFor(group);
          var forceSingleChoice = availableValues.length === 1;
          builder.querySelectorAll('[data-builder-filter="' + group + '"]').forEach(function (button) {
            var value = button.dataset.builderValue;
            var visible = value === 'all' ? !forceSingleChoice : availableValues.indexOf(value) !== -1;
            var selected = filterState[group] === value;
            button.hidden = !visible;
            button.disabled = !visible;
            button.classList.toggle('is-active', selected);
            button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
        });
      }

      function renderModelCard(card) {
        var handle = card.dataset.builderModel;
        var rule = ruleFor(handle);
        var profile = profiles[handle];
        if (!rule || !profile) return;
        var family = card.querySelector('[data-builder-card-family]');
        var tags = card.querySelector('[data-builder-card-tags]');
        var image = card.querySelector('img');
        var configuration = configurations.find(function (item) { return item.dataset.builderConfiguration === handle; });
        var firstVariant = configuration && (configuration.querySelector('[data-builder-variant].is-active') || configuration.querySelector('[data-builder-variant]'));
        var firstColorway = firstVariant ? firstVariant.dataset.builderVariantLabel : '';
        var exactMedia = (firstVariant && firstVariant.dataset.variantMedia) || exactMediaFor(handle, firstColorway);
        if (image && exactMedia) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = exactMedia;
          image.alt = rule.name + ' — ' + firstColorway;
          image.loading = 'eager';
          image.decoding = 'async';
        }
        if (family) family.textContent = 'Wrist Pinnacle / ' + rule.family;
        if (tags) tags.innerHTML = profile.tags.map(function (tag) { return '<span>' + tag + '</span>'; }).join('');
      }

      function displayFilterValue(value) {
        return String(value || '').replace(/-/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
      }

      function updateGuidance(available, matchingHandles) {
        var active = Object.keys(filterState).filter(function (group) { return explicitFilters.has(group) && filterState[group] !== 'all'; });
        manualButtons.forEach(function (button) {
          var selected = button.dataset.builderManualFilter === 'function' && button.dataset.builderManualValue === filterState.function;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (!stateLabel || !stateCopy) return;
        if (available === 0) {
          stateLabel.textContent = 'Try another direction';
          stateCopy.textContent = 'This combination conflicts with the current range. Reset one choice to reopen compatible paths.';
          return;
        }
        if (available === 1) {
          var card = modelButtons.find(function (item) { return item.dataset.builderModel === matchingHandles[0]; });
          var title = card && card.querySelector('.wp-builder__model-copy strong');
          stateLabel.textContent = 'One watch to explore';
          stateCopy.textContent = (title ? title.textContent.trim() : 'This watch') + ' matches what you have in mind. Explore its finishes below.';
          return;
        }
        if (active.length === 0) {
          stateLabel.textContent = 'Start broad';
          stateCopy.textContent = 'Choose a function or series. Compatible options remain visible; incompatible ones disappear.';
          return;
        }
        var selectionValues = [];
        active.forEach(function (group) {
          var label = displayFilterValue(filterState[group]);
          if (selectionValues.indexOf(label) === -1) selectionValues.push(label);
        });
        var selection = selectionValues.join(' + ');
        stateLabel.textContent = available + ' watches to explore';
        stateCopy.textContent = selection + ' brings these watches into view. Choose one that catches your eye, or narrow the details a little more.';
      }

      function updateFilters(preferredGroup, shouldFocusSelection) {
        reconcileFilterState(preferredGroup);
        syncFilterControls();
        var available = 0;
        var matchingHandles = [];
        var activeSelected = builder.querySelector('[data-builder-model].is-active');
        modelButtons.forEach(function (card) {
          var match = matchesFilters(card.dataset.builderModel);
          card.hidden = !match;
          if (match) {
            available += 1;
            matchingHandles.push(card.dataset.builderModel);
          }
        });
        if (resultCount) resultCount.textContent = available + (available === 1 ? ' watch available' : ' watches available');
        if (noResults) noResults.hidden = available !== 0;
        if (available === 1) {
          if (!activeSelected || activeSelected.dataset.builderModel !== matchingHandles[0]) {
            selectModel(matchingHandles[0], { focus: Boolean(shouldFocusSelection) });
          }
        } else if (activeSelected && activeSelected.hidden) {
          closeSelection();
        }
        updateGuidance(available, matchingHandles);
      }

      function closeSelection() {
        modelButtons.forEach(function (card) {
          card.classList.remove('is-active');
          card.setAttribute('aria-pressed', 'false');
        });
        configurations.forEach(function (configuration) { configuration.hidden = true; });
        if (selector) selector.hidden = true;
      }

      function selectModel(handle, options) {
        options = options || {};
        var rule = ruleFor(handle);
        var profile = profiles[handle];
        if (!rule || !profile) return;
        modelButtons.forEach(function (card) {
          var selected = card.dataset.builderModel === handle;
          card.classList.toggle('is-active', selected);
          card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        configurations.forEach(function (configuration) {
          var selected = configuration.dataset.builderConfiguration === handle;
          configuration.hidden = !selected;
          if (!selected) return;
          var family = configuration.querySelector('[data-builder-family]');
          var architecture = configuration.querySelector('[data-builder-architecture]');
          var components = configuration.querySelector('[data-builder-components]');
          if (family) family.textContent = rule.family;
          if (architecture) architecture.textContent = '' + rule.visibleArchitecture.join(' · ') + '.';
          if (components) components.innerHTML = profile.components.map(function (component) {
            return '<div class="wp-builder__component"><span>' + component[0] + '</span><strong>' + component[1] + '</strong></div>';
          }).join('');

          var componentOptions = configuration.querySelector('[data-builder-component-options]');
          var componentDisclaimer = configuration.querySelector('[data-builder-component-disclaimer]');
          if (componentOptions) {
            componentOptions.innerHTML = Object.entries(rule.componentOptions || {}).map(function (entry) {
              var key = entry[0];
              var choices = entry[1];
              return '<div class="wp-builder__component-group">' +
                '<span class="wp-builder__component-group-title">' + escapeHtml(componentLabel(key)) + '</span>' +
                '<div class="wp-builder__component-choice-list">' + choices.map(function (choice, index) {
                  var current = choice.state === 'current';
                  if (!current) {
                    return '<span class="wp-builder__component-choice--future" title="Watch detail">' + escapeHtml(choice.value) + '<small>Reference</small></span>';
                  }
                  return '<button class="wp-builder__component-choice' + (index === 0 ? ' is-active' : '') + '" type="button" data-builder-component-choice data-component-category="' + escapeHtml(key) + '" aria-pressed="' + (index === 0 ? 'true' : 'false') + '">' + escapeHtml(choice.value) + '</button>';
                }).join('') + '</div></div>';
            }).join('');
          }
          if (componentDisclaimer) componentDisclaimer.textContent = 'The details of this design. Choose your finish below to take a closer look at that exact watch.';
          renderPalette(configuration, handle);
          var initialVariantButton = configuration.querySelector('[data-builder-variant].is-active');
          if (initialVariantButton) syncSelectedColorway(configuration, initialVariantButton);
          syncSizeState(configuration);
        });
        if (selector) {
          selector.hidden = false;
          if (options.focus) selector.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      modelButtons.forEach(function (card) {
        renderModelCard(card);
        card.addEventListener('click', function () { selectModel(card.dataset.builderModel, { focus: true }); });
      });

      builder.querySelectorAll('[data-builder-filter]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (button.hidden || button.disabled) return;
          var group = button.dataset.builderFilter;
          var value = button.dataset.builderValue;
          filterState[group] = value;
          if (value === 'all') explicitFilters.delete(group);
          else explicitFilters.add(group);
          updateFilters(group, true);
        });
      });

      builder.querySelectorAll('[data-builder-manual-filter]').forEach(function (button) {
        button.addEventListener('click', function () {
          var group = button.dataset.builderManualFilter;
          var value = button.dataset.builderManualValue;
          if (!Object.prototype.hasOwnProperty.call(filterState, group)) return;
          filterState[group] = value;
          if (value === 'all') explicitFilters.delete(group);
          else explicitFilters.add(group);
          updateFilters(group, true);
          var matchingCount = modelButtons.filter(function (card) { return !card.hidden; }).length;
          if (matchingCount > 1) {
            builder.querySelector('.wp-builder__filters')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      // Questionnaire navigation clears model filters without discarding the chosen size.
      builder.addEventListener('wp:clear-model-filters', function () {
        Object.keys(filterState).forEach(function (group) { filterState[group] = 'all'; });
        explicitFilters.clear();
        var url = new URL(window.location.href);
        ['model', 'variant'].concat(Object.keys(filterState)).forEach(function (key) { url.searchParams.delete(key); });
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
        closeSelection();
        updateFilters(null, false);
      });

      builder.querySelector('[data-builder-reset]')?.addEventListener('click', function () {
        filterState = { family: 'all', function: 'all', movement: 'all', bezel: 'all', form: 'all', dial: 'all', bracelet: 'all', price: 'all' };
        selectedSize = '40';
        builder.querySelectorAll('[data-builder-size-disclosure]').forEach(function (details) { details.open = false; });
        explicitFilters.clear();
        var resetUrl = new URL(window.location.href);
        ['model', 'variant', 'family', 'function', 'movement', 'bezel', 'form', 'dial', 'bracelet', 'price'].forEach(function (key) { resetUrl.searchParams.delete(key); });
        window.history.replaceState({}, '', resetUrl.pathname + resetUrl.search + resetUrl.hash);
        if (advancedFilters) advancedFilters.open = false;
        closeSelection();
        updateFilters(null, false);
        syncAllSizeStates();
      });

      builder.addEventListener('click', function (event) {
        var paletteChoice = event.target.closest('[data-builder-palette-choice]');
        if (paletteChoice) {
          var paletteConfiguration = paletteChoice.closest('[data-builder-configuration]');
          var matchingVariantButton = paletteConfiguration && Array.prototype.slice.call(paletteConfiguration.querySelectorAll('[data-builder-variant]')).find(function (button) {
            return button.dataset.builderVariantLabel === paletteChoice.dataset.builderPaletteLabel;
          });
          if (matchingVariantButton) matchingVariantButton.click();
          return;
        }
        var sizeChoice = event.target.closest('[data-builder-size]');
        if (sizeChoice) {
          selectedSize = sizeChoice.dataset.builderSize || '40';
          syncAllSizeStates();
          return;
        }
        var choice = event.target.closest('[data-builder-component-choice]');
        if (!choice) return;
        var configuration = choice.closest('[data-builder-configuration]');
        if (!configuration) return;
        var category = choice.dataset.componentCategory;
        configuration.querySelectorAll('[data-builder-component-choice]').forEach(function (item) {
          if (item.dataset.componentCategory !== category) return;
          var selected = item === choice;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var disclaimer = configuration.querySelector('[data-builder-component-disclaimer]');
        if (disclaimer) disclaimer.textContent = 'Choose a finish below to see the exact watch, price and ordering options.';
      });

      configurations.forEach(function (configuration) {
        configuration.querySelectorAll('[data-builder-variant]').forEach(function (button) {
          button.addEventListener('click', function () {
            configuration.querySelectorAll('[data-builder-variant]').forEach(function (item) {
              var selected = item === button;
              item.classList.toggle('is-active', selected);
              item.setAttribute('aria-pressed', selected ? 'true' : 'false');
            });
            syncSelectedColorway(configuration, button);
          });
        });
      });

      function applyInitialQuery() {
        var requestedModel = initialQuery.get('model');
        if (requestedModel && profiles[requestedModel]) {
          var requestedVariant = initialQuery.get('variant');
          var requestedConfiguration = configurations.find(function (configuration) { return configuration.dataset.builderConfiguration === requestedModel; });
          if (requestedConfiguration && requestedVariant) {
            var variantChoices = Array.prototype.slice.call(requestedConfiguration.querySelectorAll('[data-builder-variant]'));
            if (variantChoices.some(function (choice) { return choice.dataset.variantId === requestedVariant; })) {
              variantChoices.forEach(function (choice) {
                var selected = choice.dataset.variantId === requestedVariant;
                choice.classList.toggle('is-active', selected);
                choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
              });
            }
          }
          Object.keys(filterState).forEach(function (group) {
            var values = profileValues(requestedModel, group);
            filterState[group] = values.length === 1 ? values[0] : 'all';
            if (filterState[group] !== 'all') explicitFilters.add(group);
          });
          updateFilters(null, true);
          return;
        }
        var applied = false;
        Object.keys(filterState).forEach(function (group) {
          var value = initialQuery.get(group);
          var control = value && builder.querySelector('[data-builder-filter="' + group + '"][data-builder-value="' + value + '"]');
          if (control) {
            filterState[group] = value;
            explicitFilters.add(group);
            applied = true;
            if (advancedFilters && group !== 'family' && group !== 'function') advancedFilters.open = true;
          }
        });
        updateFilters(null, applied);
      }

      var optionalGuidance = builder.querySelector('.wp-builder__optional-guidance');
      function openLinkedGuidance() {
        if (optionalGuidance && (window.location.hash === '#find-your-starting-point' || window.location.hash === '#starting-point')) optionalGuidance.open = true;
      }
      openLinkedGuidance();
      window.addEventListener('hashchange', openLinkedGuidance);
      applyInitialQuery();
      syncAllSizeStates();
    });
  }
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
